import React, { useEffect } from 'react';
import { Bot } from 'lucide-react';
import { useUI } from '../../contexts/UIContext';
import { useWeb3 } from '../../contexts/Web3Context';

const AIAssistant = () => {
  const { aiMessageVisible, aiMessage, toggleAiMessage, showAiMessage } = useUI();
  const { userInfo, isConnected } = useWeb3();

  // Show initial message or welcome message on connection
  useEffect(() => {
    if (isConnected) {
      const message = userInfo 
        ? `Welcome back! Your investment of ${parseFloat(userInfo.totalDepositUSDT).toFixed(2)} USDT is performing well. You have ${userInfo.refCount} direct referrals.`
        : 'Welcome to GrichInv! Start your journey by making your first investment. Minimum investment is just 6 USDT.';
      
      showAiMessage(message, 5000);
    } else {
      showAiMessage('Welcome to GrichInv. Connect your wallet to get started.', 5000);
    }
  }, [isConnected, userInfo]);

  // Handle click on the bot icon
  const handleBotClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    toggleAiMessage();
  };

  return (
    <div className="ai-assistant">
      <div 
        className={`ai-message ${aiMessageVisible ? 'active' : ''}`}
        onClick={(e) => e.stopPropagation()} // Prevent clicks from passing through
      >
        <p>{aiMessage}</p>
      </div>
      <div className="ai-icon" onClick={handleBotClick}>
        <Bot size={24} />
      </div>
    </div>
  );
};

export default AIAssistant;